import React, { useState } from "react";
import "./Blog.css";
import { Helmet } from "react-helmet-async";

const blogs = [
  {
    id: 1,
    title: "A Reliable Guide to Cleaning Anal Toys",
    image: "/image/c1.jpg",
    short:
      "Learn how to clean anal toys properly to maintain hygiene, safety, and long-term use.",
    full:
      "Cleaning anal toys is essential for hygiene and safety. Always wash toys before and after use using warm water and a toy-safe cleaner. Avoid harsh chemicals, dry completely, and store separately to prevent bacteria buildup."
  },
  {
    id: 2,
    title: "Beginner’s Guide to Using Adult Toys Safely",
    image: "/image/c4.jpg",
    short:
      "New to adult toys? This beginner-friendly guide explains safety, usage, and care tips.",
    full:
      "If you are new to adult toys, start with body-safe materials like medical-grade silicone. Use water-based lubricants, follow instructions carefully, clean toys properly, and store them safely for a comfortable and safe experience."
  },
  {
    id: 3,
    title: "How Cock Rings Can Enhance Sexual Pleasure",
    image: "/image/c2.jpg",
    short:
      "Discover how cock rings work, their benefits, and how to use them safely.",
    full:
      "Cock rings help maintain stronger erections by improving blood flow and delaying ejaculation. When used correctly, they can enhance pleasure for both partners. Always choose the right size and avoid prolonged use."
  },
  {
    id: 4,
    title: "How to Choose the Right Sex Toy for Your Needs",
    image: "/image/c5.jpg",
    short:
      "Confused about buying sex toys? Learn how to choose the right product based on comfort and experience.",
    full:
      "Choosing the right sex toy depends on your comfort level, experience, and personal preferences. Beginners should opt for simple designs made from body-safe materials. Always buy from trusted stores offering discreet delivery."
  },
  {
    id: 5,
    title: "Why Discreet Delivery Matters When Buying Adult Products",
    image: "/image/c6.jpg",
    short:
      "Understand why discreet packaging is important when ordering adult products online.",
    full:
      "Discreet delivery ensures privacy and peace of mind. Trusted adult stores ship products in plain packaging without revealing product details."
  },
  {
    id: 6,
    title: "Best Practices for Storing Sex Toys Safely",
    image: "/image/c7.jpg",
    short:
      "Learn how to store sex toys correctly to maintain hygiene and product lifespan.",
    full:
      "Always clean and dry sex toys before storage. Store them in individual pouches away from dust and moisture."
  },
  {
    id: 7,
    title: "Understanding Body-Safe Materials in Adult Toys",
    image: "/image/c8.jpg",
    short:
      "Learn why body-safe materials like silicone are important when choosing adult toys.",
    full:
      "Body-safe materials such as medical-grade silicone are non-toxic, non-porous, and safe for skin contact."
  }
];

const Blog = () => {
  const [activeBlog, setActiveBlog] = useState(null);

  return (
    <>
      {/* 🔥 HIGH LEVEL SEO */}
      <Helmet>
        <title>
          Adult Wellness & Sex Toy Blog in India | Delhi, Mumbai, Bangalore
        </title>

        <meta
          name="description"
          content="Read expert adult wellness & sex toy blogs in India. Safety guides, buying tips & product care advice for Delhi, Mumbai, Bangalore, Chennai, Hyderabad & all major cities."
        />

        <meta
          name="keywords"
          content="
          adult wellness blog india,
          sex toy blog india,
          adult toy safety guide,
          sex toys cleaning guide,
          discreet delivery adult products,
          sex toy blog delhi,
          sex toy blog mumbai,
          sex toy blog bangalore,
          sex toy blog chennai,
          sex toy blog hyderabad
          "
        />

        <link rel="canonical" href="https://lushdesire.in/blog" />
      </Helmet>

      <section className="blog-page">
        <div className="blog-container">

          {/* ✅ ONE MAIN H1 */}
          <h1 className="blog-heading">
            Adult Wellness & Sex Toy Blog in India
          </h1>

          {/* 🔥 FULL BLOG VIEW */}
          {activeBlog && (
            <article
              className="blog-card"
              style={{ maxWidth: "900px", margin: "0 auto 60px" }}
            >
              <div className="blog-img">
                <img
                  src={activeBlog.image}
                  alt={activeBlog.title}
                  loading="lazy"
                />
              </div>

              <div className="blog-content">
                {/* 🔥 Blog title as H2 */}
                <h2>{activeBlog.title}</h2>
                <p>{activeBlog.full}</p>

                <button
                  className="read-btn"
                  onClick={() => setActiveBlog(null)}
                >
                  ← Back to Blogs
                </button>
              </div>
            </article>
          )}

          {/* 🔹 BLOG GRID */}
          <div className="blog-grid">
            {blogs.map((blog) => (
              <article className="blog-card" key={blog.id}>
                <div className="blog-img">
                  <img
                    src={blog.image}
                    alt={`${blog.title} | Adult wellness blog India`}
                    loading="lazy"
                  />
                </div>

                <div className="blog-content">
                  {/* 🔥 Card title as H3 */}
                  <h3>{blog.title}</h3>
                  <p>{blog.short}</p>

                  <button
                    className="read-btn"
                    onClick={() => setActiveBlog(blog)}
                  >
                    Read more →
                  </button>
                </div>
              </article>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};

export default Blog;
